export function feeCardTypesBuilderForUI(card) {
  return {
    feeCardId: card.FeeCardId,
    feeCardDesc: card.FeeCardDesc,
  };
}
